<template>
  <div :class="inlinerows == 'true' ? 'mb-3 row' : 'mb-3'">
    <label v-if="label" for="exampleFormControlInput1" :class="inlinerows == 'true' ? 'col-sm-2 col-form-label' : 'form-label'">{{ label }}</label>
    <div :class="inlinerows == 'true' ? 'col-sm-10' : label ? '' : 'col-md-12'">
      <div class="input-group">
        <b-form-select v-model="selected" :options="options" :class="classes"></b-form-select>
        <div class="input-group-append">
          <my-button :fa="btn_fa" :label="btn_label" :variant="btn_variant" :classes="btn_classes" :height="btn_height" :width="btn_width" @onClick="click"></my-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../../assets/scss/form-group.scss";
import "../../assets/scss/select-input-group.scss";
import MyButton from "../atoms/Button.vue";

export default {
  name: "select-input-group",
  components: {
    MyButton,
  },
  data() {
    return {
      selected: null,
      text: "",
    };
  },
  created() {},
  props: {
    label: {
      type: String,
      required: true,
    },
    classes: {
      type: String,
      default: "",
    },

    mandatory: {
      // type: Boolean,
      default: false,
    },
    data: {
      //type: Object,
      required: true,
    },
    // valuefield: {
    //   type: String,
    //   required: true,
    //   default: 'id',
    // },
    // textfield: {
    //   type: String,
    //   required: true,
    //   default: 'name',
    // },
    inlinerows: {
      // type: Boolean,
      default: false,
    },

    btn_label: {
      type: String,
      default: "",
    },
    btn_variant: {
      type: String,
      default: "",
    },
    btn_fa: {
      type: String,
      default: "",
    },
    btn_size: {
      type: String,
      validator: function(value) {
        return ["small", "medium", "large"].indexOf(value) !== -1;
      },
    },
    btn_classes: {
      type: String,
      default: "",
    },
    btn_width: {
      type: String,
      default: "",
    },
    btn_minwidth: {
      type: String,
      default: "",
    },
    btn_height: {
      type: String,
      default: "",
    },
  },
  methods: {
    click() {
      this.$emit("click", this.selected);
    },
  },

  computed: {
    options() {
      return this.$props.data
        ? this.$props.data.map((item) => {
            item.text = this.$t(item.text);
            return item;
          })
        : [];
    },
  },
};
</script>
